<template>
    <div
        v-click-outside="close"
        :tabindex="disabled ? -1 : 0"
        @focusin="handleFocus"
        @focusout="handleFocusOut"
        ref="container"
        @keydown.space="handleKeyOpenEvent"
        @keydown.up="handleKeyOpenEvent"
        @keydown.down="handleKeyOpenEvent"
        :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
        :disabled="disabled"
    >
        <div ref="trigger" @click="toggleOpen">
            <slot name="trigger" :is-open="isOpen" :is-focused="isFocused"></slot>
        </div>

        <div v-show="isOpen" v-trap-focus="isOpen" @click.stop>

            <div
                ref="content"
                class="hidden md:block z-top"
            >
                <transition-group name="slide-fade">
                    <slot name="content" v-if="isOpen"></slot>
                </transition-group>
            </div>

            <div
                class="md:hidden fixed inset-0 z-top"
            >
                <div
                    class="absolute inset-0 bg-primary opacity-50"
                    @click.stop="close"
                ></div>
                <div class="absolute inset-x-0 bottom-0 pt-24 pl-24">
                    <div class="mb-24 mr-24">
                        <slot name="content" :is-open="isOpen"></slot>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { createPopper } from '@popperjs/core';
import clickOutside from '../mixins/clickOutside';
import trapFocus from '../mixins/trapFocus';

export default {
    components: {
    },
    mixins: [
        clickOutside,
        trapFocus,
    ],
    model: {
    },
    props: {
        matchWidth: Boolean,
        disabled: Boolean,
        align: {
            default: 'start',
            validator: value => ['start', 'end'].includes(value),
        }
    },
    data: function () {
        return {
            _popperInstance: undefined,
            isFocused: false,
            isOpen: false,
        };
    },
    computed: {
    },
    methods: {
        open () {
            this.isOpen = true;
            this._popperInstance.update();
            this.$emit('open');
        },
        close () {
            this.isOpen = false;
            this.$emit('close');
        },
        toggleOpen () {

            if (this.disabled) {
                return;
            }

            this.isOpen ? this.close() : this.open();
        },
        handleKeyOpenEvent (event) {

            if (this.disabled) {
                return;
            }

            if (this.isOpen) {
                return this.$emit('keydown', event);
            }

            event.preventDefault();
            this.toggleOpen();
        },
        setFocus () {
            if (this.disabled) {
                return;
            }

            this.$refs.container.focus();
        },
        handleFocus () {
            this.isFocused = true;
            this.$emit('focusin');
        },
        handleFocusOut () {
            this.isFocused = false;
            this.$emit('focusout');
        },
        updatePopper () {

            if (!this._popperInstance) {
                return;
            }

            this._popperInstance.update();
        }
    },
    mounted () {

        if (this.isOpen) {
            // this.setFocus()
        }

        let trigger = this.$refs.trigger;
        let content = this.$refs.content;

        this._popperInstance = createPopper(trigger, content, {
            placement: 'bottom-' + this.align,
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: ['top-' + this.align],
                    },
                },
                {
                    name: 'offset',
                    options: {
                        offset: [0, 5],
                    },
                },
                ...[this.matchWidth ? {
                    name: 'setPopperWidth',
                    enabled: true,
                    phase: 'beforeWrite',
                    fn: ({state}) => {
                        state.styles.popper.width = state.rects.reference.width + 'px';
                    }
                } : {}],
            ],
        });
    }
}
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
}

.slide-fade-enter {
    transform: translateY(-10px);
}

.slide-fade-leave-to {
    transform: translateY(10px);
}
</style>
